// extracted by mini-css-extract-plugin
export default {"grid":"TemplatesGrid_grid__eQjWE"};